module.exports = {
  schema: {
    name: '價格資料',
    type: 'Object',
    contents: {
      priceRangeRef: {
        type: 'ObjectId',
        reference: 'priceRanges',
        name: '價格範圍代碼',
        refKeys: ['key'],
      },
      productRef: {
        type: 'ObjectId',
        reference: 'products',
        name: '商品代碼',
        refKeys: ['key'],
        required: true,
      },
      pricebookRef: {
        type: 'ObjectId',
        reference: 'pricebooks',
        name: '價格表',
        refKeys: ['key'],
        required: true,
      },
      price: {
        type: 'Number',
        name: '價格',
        required: true,
      },
    },
  },
  index: {
    primary: {
      key: {
        priceRangeRef: 1,
        productRef: 1,
        pricebookRef: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'productRef', width: 150 },
        { key: 'priceRangeRef', width: 150 },
        { key: 'pricebookRef', width: 250 },
        { key: 'price' },
      ],
    },
    editor: {
      config: {
        nameWidth: 120,
      },
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'productRef' }],
            [{ key: 'priceRangeRef' }],
            [{ key: 'pricebookRef' }],
            [{ key: 'price' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/prices.js